import { red } from '@mui/material/colors';
import AllocationCell from 'components/AllocationCell';
import { useQuery } from 'react-query';
import { putTestData } from 'services/apiCalls';
import usePreSeasonDistinctFeatures from './usePreSeasonDistinctFeatures';
const GroupRowValues = (row: any, item: any, tableRows: any) => {
  console.log(row);
  let cols = ['MD_DESC', 'SC_DESC', 'CL_DESC'];
  cols.forEach(col => {
    const found = tableRows.some((el: any) => el[col] === item[col]);
    if (found) {
      row[col] = '';
    }
  });
};
export default function usePreSeasonTableData(
  class_list: string[],
  start_year: string,
  start_month: string,
  end_year: string = '',
  end_month: string = '',
  store_list: string[] = [],
  dept_list: string[] = [],
  sub_category_list: string[] = [],
  flag: boolean = false
) {
  const path = `first_allocation/tabelView`;

  const { distinctRows } = usePreSeasonDistinctFeatures(
    class_list,
    start_year,
    start_month,
    end_year,
    end_month,
    store_list,
    dept_list,
    sub_category_list,
    flag
  );
  const { data, isLoading } = useQuery(
    [
      'tabelView',
      class_list,
      start_year,
      start_month,
      end_year,
      end_month,
      store_list,
      dept_list,
      sub_category_list,
      flag,
    ],
    () =>
      putTestData(path, {
        class_list,
        start_year,
        start_month,
        end_year,
        end_month,
        store_list,
        dept_list,
        sub_category_list,
        flag,
      }),
    {
      enabled:
        !!start_year &&
        !!start_month &&
        !!class_list.length &&
        Array.isArray(store_list) &&
        !!store_list.length,
    }
  );

  const columnDefs: any = [
    {
      headerName: 'Hierarchy Details',
      children: [
        {
          headerName: 'Department',
          field: 'MD_DESC',
          pinned: 'left',
          width: 150,
          headerTooltip: 'Department',
          tooltipField: 'MD_DESC',
        },
        {
          headerName: 'Sub category',
          field: 'SC_DESC',
          pinned: 'left',
          headerTooltip: 'Sub-Category',
          tooltipField: 'SC_DESC',
          width: 180,
        },
        {
          headerName: 'Class description',
          field: 'CL_DESC',
          pinned: 'left',
          headerTooltip: 'Class Description',
          tooltipField: 'CL_DESC',
        },
        { headerName: 'Store', field: 'STORE_ID', pinned: 'left', hide: !flag, width: 120 },
        { headerName: 'Region', field: 'RG_DESC', pinned: 'left', hide: flag, width: 120 },
      ],
    },
  ];
  const tableRows: any = [];
  const months: any = [];
  if (Array.isArray(data) && Array.isArray(distinctRows) && distinctRows.length && data.length) {
    distinctRows.forEach((item: any) => {
      let row: any = {};
      data.forEach((dataItem: any) => {
        if (
          item.CL_ID === dataItem.CL_ID &&
          item.CL_DESC === dataItem.CL_DESC &&
          item.MD_DESC === dataItem.MD_DESC &&
          item.SC_DESC === dataItem.SC_DESC &&
          item.RG_DESC === dataItem.RG_DESC
        ) {
          row = {
            ...item,
            ...row,
            [`${dataItem.month_year}--Forecast_Sales`]: dataItem.Forecast_Sales,
            [`${dataItem.month_year}--Adjusted_Forecasted_Sales`]:
              dataItem.Adjusted_Forecasted_Sales,
            [`${dataItem.month_year}--deviation`]: dataItem.Perct_SLS_UNTS_Change,
            [`${dataItem.month_year}--Current_Sales`]: dataItem.Current_Sales,
            [`${dataItem.month_year}--Last_Season_Sales`]: dataItem.Last_Season_Sales,
            [`${dataItem.month_year}--Forecast_Sales_Dollars`]: dataItem.Forecast_Sales_Dollars,
          };
          if (!months.includes(dataItem.month_year)) {
            months.push(dataItem.month_year);
          }
        }
        GroupRowValues(row, item, tableRows);
      });
      tableRows.push(row);
    });
  }
  if (Array.isArray(months) && months.length) {
    months.forEach((month: any) => {
      columnDefs.push({
        headerName: month,
        children: [
          {
            field: `${month}--Last_Season_Sales`,
            headerName: 'Historical sales',
            minWidth: 150,
          },
          {
            field: `${month}--Forecast_Sales_Dollars`,
            headerName: 'Forecast sales ($)',
            minWidth: 200,
          },
          {
            field: `${month}--Forecast_Sales`,
            headerName: 'Forecast sales',
            cellRendererFramework: AllocationCell,
            minWidth: 150,
            cellStyle: (params: any) => {
              const colId = params?.column?.getColId();
              const monthYear = colId?.split('--')[0];
              const deviation = params.data[`${monthYear}--deviation`];
              if (deviation <= -50) {
                return { backgroundColor: red['A100'] };
              }
            },
          },
          {
            field: `${month}--Adjusted_Forecasted_Sales`,
            headerName: 'Adjustment',
            minWidth: 150,
            headerComponentParams: { editable: true },
            editable: (params: any) => {
              const colId = params?.column?.getColId();
              const monthYear = colId?.split('--')[0];
              const value = params.data[`${monthYear}--Forecast_Sales`];
              return value !== undefined && value !== null && value !== '' && flag;
            },
            cellStyle: { borderRight: '1px solid #ccc' },
          },
        ],
      });
    });
  }
  return { columnDefs, tableRows, isLoading };
}
